import { useState, useEffect } from 'react';
import { ProductInfoViewType } from '../types/view/product-info-view-type';
import { PurchasedProductsApiType } from '../types/api/purchased-products-api-type';

export const usePausedProducts = (
  registeredProducts: ProductInfoViewType[],
  purchasedProductsData: PurchasedProductsApiType
) => {
  const [pausedProducts, setPausedProducts] = useState<ProductInfoViewType[]>([]);

  useEffect(() => {

    const filtered = purchasedProductsData.reduce((accumlator, current) => {

      // プランが一つのみの場合を想定。それ以上の場合はsellingPlanIdも考慮する必要あり
      const notFoundInRegisteredProducts = registeredProducts.every((product) => {
        return product.variantId !== current.variantId;
      });

      if (notFoundInRegisteredProducts) {

        accumlator.push({
          productTitle: current.productTitle,
          image: current.image,
          variantTitle: current.variantTitle,
          originalPrice: current.originalPrice,
          price: current.price,
          quantity: 0,
          variantId: current.variantId,
          planId: current.planId,
          url: current.url,
          active: false,
        });
      }

      return accumlator;

    }, [] as ProductInfoViewType[]);

    setPausedProducts(filtered);

  }, [registeredProducts, purchasedProductsData]);

  return pausedProducts;
};
